import React from "react";
import { Button, Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from "@mui/material"
import BarChartIcon from '@mui/icons-material/BarChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import { formatNumber, transformChartDataToTable } from "../../../../helpers/UtilityHelper";
import { Box } from "@mui/system";
import { DualAxisChart } from "../../../charts/CompositChart";
import { PAYMENT_COLORS, MUTED_BAR } from "../../../charts/colors";
import MaterialTable from "../../../../common/MaterialTable";

export default function SplitInLineChart({ data }) {
    const [showCount, setShowCount] = React.useState(true)
    const [view, setView] = React.useState("chart")

    const { rows, allColumns } = transformChartDataToTable(data, [
        { key: 'rtoPercentage', 'label': 'RTO %', order: 2 },
        { key: 'PREPAID', 'label': 'Prepaid %', order: 1 },
        { key: 'COD', 'label': 'COD %', order: 0 },
    ])

    // Like CT, give the RTO% axis plenty of headroom so the stacked area band
    // stays in the lower portion of the chart and never rises above the count
    // bars. We scale the axis so the tallest stacked point lands at ~30% height.
    const maxStacked = (data || []).reduce(
        (max, d) => Math.max(max, (Number(d.COD) || 0) + (Number(d.PREPAID) || 0)),
        0
    )
    const leftMax = maxStacked > 0 ? Math.ceil((maxStacked / 0.3) / 5) * 5 : 12

    const chartOptions = {
        layout: 'horizontal',
        xaxis: 'name',
        showLabels: true,
        legendAlign: 'center',
        yaxis: {
            left: {
                label: 'RTO %',
                domain: [0, leftMax],
                data: [
                    {
                        dataKey: 'COD',
                        unit: '%',
                        label: 'COD RTO %',
                        chartType: 'area',
                        stackId: 'rto',
                        fill: PAYMENT_COLORS.COD,
                        fillOpacity: 0.5,
                    },
                    {
                        dataKey: 'PREPAID',
                        unit: '%',
                        label: 'PREPAID RTO %',
                        chartType: 'area',
                        stackId: 'rto',
                        fill: PAYMENT_COLORS.PREPAID,
                        fillOpacity: 0.45,
                    },
                ],
            },
        },
    }

    const tableColumns = [
        {
            label: 'Name',
            value: 'name',
            align: 'left'
        },
        ...(allColumns.map((z) => ({
            numeric: true,
            align: 'right',
            value: (row) => {
                return formatNumber(row[z])
            },
            label: z
        })))
    ]

    if (showCount) {
        chartOptions.yaxis.right = {
            label: '# RTO Shipments',
            data: [
                {
                    dataKey: 'totalRtoCases',
                    label: 'Total RTO Shipments',
                    chartType: 'bar',
                    fill: MUTED_BAR,
                    fillOpacity: 0.95,
                },
            ],
        }
    } else {
        delete chartOptions.yaxis.right
    }

    return (
        <Card elevation={1}>
            <CardHeader title="RTO Trends" action={(
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button size="small" onClick={() => setShowCount(st => !st)} variant={showCount ? "contained" : "outlined"} sx={{ mr: 1 }}>Show Count</Button>
                    <ToggleButtonGroup color="primary" size="small" exclusive onChange={(e, v) => setView(v)} value={view}>
                        <ToggleButton value="chart">
                            <BarChartIcon />
                        </ToggleButton>
                        <ToggleButton value="table">
                            <TableChartIcon />
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            )} />
            <CardContent>
                {(view === 'chart') && (<DualAxisChart data={data} chartOptions={chartOptions} height={480} />)}
                {(view === 'table') && (<MaterialTable size="small" exportExcel={false} rows={rows} columns={tableColumns} frozenColumnsCount={1} />)}
            </CardContent>
        </Card>
    )
}